/*重构的模型训练的接口功能*/
import axios from '../index'
// import qs from "qs";
import api from './common.api'
import bus from '@/utils/bus'
export default {
  /**
   * 统计文件压缩包里的数量 @data strAimPath
   */
  FileInZipCount(strAimPath) {
    return axios({
      url: api.FileInZipCount,
      method: 'post',
      params: { strAimPath: strAimPath },
    })
  },
  /**
   * 单个文件上传进度条 @data uploadFile
   */
  UploadFileProgressBar(file) {
    return axios({
      url: `${api.UploadFile}?bucketName=aishixun`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data;charset=UTF-8',
        // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      // headers: {
      //     'Content-Type': 'multipart/form-data;charset=UTF-8',
      // },
      data: file,
      onUploadProgress(progress) {
        //上传进度
        let percent = Math.round((progress.loaded / progress.total) * 100)
        bus.$emit('onProgress', percent)
      },
    })
  },
  /**
        * 通过数据集ID下载文件 @data 
        “datasetId”:”String” // 数据集id
      */
  downloadDatesetFile(datasetId) {
    return axios({
      url: `${api.downloadDatesetFile}?datasetId=${datasetId}`,
      method: 'get',
    })
  },
  /**
   * 单文件上传 @data uploadFile
   * 资源平台 @data 'bucketName': 'aishixun'(桶名称)(query), file
   */
  UploadFile(data) {
    return axios({
      url: `${api.UploadFile}?bucketName=aishixun`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data;charset=UTF-8',
      },
      data: data,
    })
  },
  /**
   * 多文件上传 @data uploadFiles作为键值
   * 资源平台 @data 'bucketName': 'aishixun'(桶名称)(query), file
   */
  UploadMultipleFile(data) {
    return axios({
      url: `${api.UploadMultipleFile}?bucketName=aishixun`,
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data;charset=UTF-8',
      },
      data: data,
      onUploadProgress(progress) {},
    })
  },
  /**
   * 校验图片jpg|jpeg格式 @data {
      imgUrls: ['图片url']
   * }
   */
  verifyImgs(data = {}) {
    return axios.post(api.verifyImgs, data);
  },

  /**
   * UC平台上传图片  @data
   */
  UploadImage(data) {
    // debugger;
    return axios({
      method: 'post',
      url: api.UploadImage,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}
